module.exports = __webpack_public_path__ + "static/media/field-hockey.ff972a39.svg";